import { createSlice } from '../../utils/createAppSlice'
import { campaignInitialState as initialState } from './campaignInitialState'
import {
	resetDetailsData,
	saveDetailsData,
	updateDetailsData,
	updateStatus,
	updateListStatus,
	saveListData,
	removeCampaignFromList,
	updateCampaignName,
} from './campaignReducers'
import { getDetailsData, getDetailsStatus, getListData, getListStatus, getListPagination } from './campaignSelectors'
import { CampaignState } from './types'
import { fetchCampaignDetails, updateCampaignDetails, searchCampaigns, deleteCampaign } from './campaignAsyncMethods'
import { Status } from '../../types'

export const campaignSlice = createSlice({
	name: 'campaign',
	initialState,
	reducers: (create) => ({
		actionResetCampaignDetails: create.reducer(resetDetailsData),
		actionFetchCampaignDetails: create.asyncThunk(fetchCampaignDetails, {
			pending: (state: CampaignState) => updateStatus(state.detailsData, Status.PENDING),
			rejected: (state: CampaignState) => updateStatus(state.detailsData, Status.REJECTED),
			fulfilled: saveDetailsData,
		}),
		actionUpdateCampaignDetails: create.asyncThunk(updateCampaignDetails, {
			pending: (state: CampaignState) => updateStatus(state.detailsData, Status.PENDING),
			rejected: (state: CampaignState) => updateStatus(state.detailsData, Status.REJECTED),
			fulfilled: updateDetailsData,
		}),
		actionSearchCampaigns: create.asyncThunk(searchCampaigns, {
			pending: (state: CampaignState) => updateListStatus(state.listData, Status.PENDING),
			rejected: (state: CampaignState) => updateListStatus(state.listData, Status.REJECTED),
			fulfilled: saveListData,
		}),
		actionDeleteCampaign: create.asyncThunk(deleteCampaign, {
			fulfilled: removeCampaignFromList,
		}),
		actionUpdateCampaign: create.asyncThunk(updateCampaignDetails),
		actionUpdateCampaignName: create.asyncThunk(updateCampaignDetails, {
			pending: (state: CampaignState) => updateListStatus(state.listData, Status.PENDING),
			rejected: (state: CampaignState) => updateListStatus(state.listData, Status.REJECTED),
			fulfilled: updateCampaignName,
		}),
	}),
	selectors: {
		selectDetailsData: getDetailsData,
		selectDetailsStatus: getDetailsStatus,
		selectListData: getListData,
		selectListStatus: getListStatus,
		selectListPagination: getListPagination,
	},
})

export const {
	actionFetchCampaignDetails,
	actionUpdateCampaignDetails,
	actionResetCampaignDetails,
	actionSearchCampaigns,
	actionDeleteCampaign,
	actionUpdateCampaign,
	actionUpdateCampaignName,
} = campaignSlice.actions

export const { selectDetailsData, selectDetailsStatus, selectListData, selectListStatus, selectListPagination } =
	campaignSlice.selectors
